export const translations = {
  sv: {
    nav: {
      home: "HEM",
      services: "TJÄNSTER",
      projects: "PROJEKT",
      contact: "KONTAKT",
    },
    seo: {
      home: {
        title: "Prisvärda drönartjänster över hela Sverige | APstudios",
        description:
          "Vi erbjuder kompletta lösningar för drönarfoto, videoproduktion, 360 tours, inspektioner, ortofoton, ytmodeller, 3D-modeller, inmätning och volymberäkningar. Vi på APstudios är specialister på drönartjänster och konkurrenskraftiga på pris, innovation och kvalitet.",
      },
      foto: {
        title: "Drönarbilder | Flygfoto | 360 Bilder | APstudios",
        description:
          "Med bilder från drönare får du ett helt nytt perspektiv. Fastigheter är ett utmärkt motiv att skildra från ovan. Bilder från balkonghöjder för att visa utsikten redan innan en byggnad är uppförd är ett bra användningsområde. Eller varför inte göra ett fotomontage för att visa hur planerad bebyggelse passar in i landskapet?",
      },
      film: {
        title: "Videoproduktion | Filmproduktion | APstudios",
        description:
          "Behöver ni en säljande film för en fastighet eller ett varumärke? Med videoklipp både från marken och från luften får filmen en häftig känsla. Vi kan producera en hel film från början till slut med klippning, musik och grafik. Vi kan även leverera flygfilm till en större produktion som vill ha ett unikt perspektiv.",
      },
      ytmodeller: {
        title: "Ortofoton | Ytmodeller | Höjdkurvor | Inmätning | APstudios",
        description:
          "Vi kan leverera ortofoton, ytmodeller och höjdkurvor med hög noggrannhet. Ortofoton från drönare ger en betydligt högre detaljrikedom än Lantmäteriets kartor. När det kommer till ytmodeller kan vi ta fram både DTM och DSM. Konturlinjer kan tas fram med önskade höjdintervaller och användas i CAD-program.",
      },
      modeller3d: {
        title: "3D modeller | Punktmoln | Visualisering | APstudios",
        description:
          "Vi kan leverera 3D-modeller och punktmoln. Punktmolnen kan klassificeras med avancerade algoritmer för att exempelvis ta bort vegetation. 3D modeller kan användas till solstudier och visualisering i olika sammanhang. En 3D modell av en fastighet kan även kompletteras med laserskanning av insidan för att skapa en digital tvilling.",
      },
      volym: {
        title: "Volymberäkningar | Bergtäkter | Flis | Stockhögar | APstudios",
        description:
          "Företag med stora inventarier kan dra nytta av att enkelt kunna göra noggranna volymberäkningar. Oavsett om det handlar om flis, stockhögar eller bergtäkter har vi smarta lösningar. Vi kan leverera ett inmätt punktmoln där kunden får tillgång direkt över webben och kan ta mått.",
      },
      inspektioner: {
        title: "Inspektioner | Industrier | Fastigheter | APstudios",
        description:
          "Höghöjdsinspektion är ofta dyrt, svårt och ibland farligt men med drönare blir det enkelt och effektivt. Skorstenar, master, kraftledningar, broar, fastigheter och industrier är exempel på perfekta objekt för drönarinspektion. Leveransen kan vara bilder, film, 3D modeller eller högupplösta och mätbara ortofoton över fasader och tak.",
      },
      projekt: {
        title: "Projekt | Referenser | Uppdrag | Exempel | APstudios",
        description:
          "Vi är specialister på drönartjänster och har många års erfarenhet av att identifiera applikationer och ta fram lösningar till kunder. Vi startade 2015 med visionen att ligga i framkant när det kommer till innovation, pris och kvalitet. Vår utrustning är därför modern och diversifierad för att kunna anpassas till kundens budget och behov.",
      },
      gdpr: {
        title: "GDPR | APstudios",
        description:
          "Integritetspolicy för APstudios. Så behandlar vi personuppgifter när du kontaktar oss eller beställer ett uppdrag.",
      },
    },
    services: {
      photo: "FLYGFOTO",
      video: "VIDEOPRODUKTION",
      images360: "360 BILDER",
      surfaceModels: "YTMODELLER",
      models3d: "3D MODELLER",
      orthophotos: "ORTOFOTON",
      volumeCalculations: "VOLYMBERÄKNINGAR",
      inspections: "INSPEKTIONER",
      measurements: "INMÄTNINGAR",
      visualization: "VISUALISERING",
    },
    hero: {
      title: "Effektiva lösningar med drönare",
      description:
        "Vi erbjuder professionella drönartjänster för alla typer av projekt. Kontakta oss för en kostnadsfri konsultation.",
      contactUs: "Kontakta oss",
    },
    about: {
      title: "Aerial Picture Studios",
      description1:
        "Vi är specialister på drönartjänster med över 10 års erfarenhet av att identifiera applikationer och leverera skräddarsydda lösningar till våra kunder. Sedan starten 2015 har vi haft en tydlig vision: att ligga i framkant när det gäller innovation, pris och kvalitet. Därför arbetar vi med modern, diversifierad utrustning som kan anpassas efter både budget och behov.",
      description2:
        "Vi innehar alla nödvändiga tillstånd och försäkringar som krävs för att flyga drönare och tar alltid hänsyn till regler och risker. Vi finns i Stockholm men utför uppdrag över hela landet. Du är alltid välkommen att kontakta oss för att bolla idéer!",
    },
    serviceCards: {
      photo: {
        title: "FLYGFOTO",
        description:
          "Med bilder från drönare får du ett helt nytt perspektiv. Fastigheter är ett utmärkt motiv att skildra från ovan. Bilder från balkonghöjder för att visa utsikten redan innan en byggnad är uppförd är ett bra användningsområde. Eller varför inte göra ett fotomontage för att visa hur planerad bebyggelse passar in i landskapet?",
      },
      video: {
        title: "VIDEOPRODUKTION",
        description:
          "Behöver ni en säljande film för en fastighet eller ett varumärke? Med videoklipp både från marken från luften får filmen en häftig känsla. Vi kan producera en hel film från början till slut med klippning musik och grafik. Vi kan även leverera flygfilm till en större produktion som vill ha ett unikt perspektiv.",
      },
      inspections: {
        title: "INSPEKTIONER",
        description:
          "Höghöjdsinspektion är ofta dyrt, svårt och ibland farligt men med drönare blir det enkelt och effektivt. Skorstenar, master, kraftledningar, broar, fastigheter och industrier är exempel på perfekta objekt för drönarinspektion. Leveransen kan vara bilder, film, 3D modeller eller högupplösta och mätbara ortofoton över fasader och tak.",
      },
      surfaceModels: {
        title: "YTMODELLER",
        description:
          "Vi kan leverera ortofoton, ytmodeller och höjdkurvor med hög noggrannhet. Ortofoton från drönare ger en betydligt högre detaljrikedom än Lantmäteriets kartor. När det kommer till ytmodeller kan vi ta fram både DTM och DSM. Konturlinjer kan tas fram med önskade höjdintervaller och användas i CAD-program.",
      },
      models3d: {
        title: "3D MODELLER",
        description:
          "Vi kan leverera 3D-modeller och punktmoln. Punktmolnen kan klassificeras med avancerade algoritmer för att exempelvis ta bort vegetation. 3D modeller kan användas till solstudier och visualisering i olika sammanhang. En 3D modell av en fastighet kan även kompletteras med laserskanning av insidan för att skapa en digital tvilling.",
      },
      volumeCalculations: {
        title: "VOLYMBERÄKNINGAR",
        description:
          "Företag med stora inventarier kan dra nytta av att enkelt kunna göra noggranna volymberäkningar. Oavsett om det handlar om flis, stockhögar eller bergtäkter har vi smarta lösningar. Vi kan leverera ett inmätt punktmoln där kunden får tillgång direkt över webben och kan ta mått.",
      },
    },
    modelShowcase: {
      title: "3D modeller direkt i webbläsaren",
      loadModel: "Ladda 3D-modell",
      viewMore: "Se fler 3D-modeller",
    },
    projects: {
      readMore: "Se projektet",
      purpose: "SYFTE",
      facts: "FAKTA",
      delivery: "LEVERANS",
      client: "KUND",
      blaiken: {
        title: "BLAIKENGRUVAN",
        purpose:
          "Syftet med uppdraget var att ta fram underlag för en pågående miljöåtgärd i Blaikengruvan i Sorsele kommun. Kunden ville bland annat göra beräkningar av olika slag samt simulera hur vattennivån i dagbrottet ändrade sig givet en viss vattenmängd.",
        facts: {
          area: "Område: 460 hektar",
          resolution: "Upplösning: 3 cm/pixel",
          accuracy: "Noggrannhet: ca 4 cm",
          flightSupport: "Inmätta flygstöd: Ja",
          coordinates: "Koordinatsystem: SWEREF 99TM",
        },
      },
    },
    facts: {
      area: "Område",
      resolution: "Upplösning",
      accuracy: "Noggrannhet",
      flightSupport: "Inmätta flygstöd",
      coordinates: "Koordinatsystem",
    },
    testimonials: {
      title: "Vad våra kunder säger",
      customer: "privatkund",
    },
    references: {
      title: "Våra kunder",
    },
    footer: {
      about: {
        title: "OM OSS",
        text: "Vi är specialister på drönartjänster och har över 10 års erfarenhet av att identifiera användningsområden och ta fram lösningar till kunder. Vi innehar alla nödvändiga tillstånd och försäkringar som krävs för att flyga drönare och tar alltid hänsyn till regler och risker.",
      },
      info: {
        title: "INFO",
        address: "Adress",
        postAddress: "Postadress",
        email: "Email",
        phone: "Tel",
      },
      network: "Vi är anslutna till det rikstäckande nätverket för drönartjänster:",
    },
    servicePage: {
      imageAlt: "bild",
    },
    servicePages: {
      foto: {
        title: "FOTO",
        description:
          "Med drönarbilder kan du skildra olika motiv från ett helt nytt perspektiv. Detta öppnar upp möjligheter i en mängd olika branscher. I fastighetsbranschen är drönarbilder väldigt relevant då man får ett helhetsintryck av både tomt och byggnad. Genom att ta utsiktsfoton kan man vid nyproduktion marknadsföra balkongutsikter från olika våningsplan. Vi kan även fota interiör från marken för att komplettera drönarbilderna, vilket passar perfekt för exempelvis mäklare. Fotomontage lämpar sig väl för att visa hur planerad bebyggelse passar in i landskapet. Detta kan med fördel användas av arkitekter eller exploatörer. En 360 tour likt Google Street View låter användaren vandra runt i en virtuell värld och upptäcka en miljö eller fastighet.",
        sections: {
          utsiktsfoto: {
            title: "UTSIKTSFOTO",
            description:
              "Visa utsikten i nyproduktion genom att låta drönaren flyga upp till den planerade balkongens höjd och ta bilder. Ett balkongräcke kan även monteras i bilden för en mer verklighetstrogen känsla. Bilderna kan tas i olika väderstreck.",
          },
          fotomontage: {
            title: "FOTOMONTAGE",
            description:
              "Fotomontage lämpar sig, precis som utsiktsfoton, vid planerad bebyggelse av olika slag. Det är ofta användbart att se hur ny bebyggelse kommer passa in i miljön redan i förväg. Fotomontage är ett bra alternativ till 3D-modeller då det är enklare och lämpar sig bättre för stora områden.",
          },
          fastighetsfoto: {
            title: "FASTIGHETSFOTO",
            description:
              "Vi fotograferar alla typer av kommersiella och privata fastigheter, både från drönare och från marken. Vi kan lyfta det ni tycker är viktiga nyckelpunkter för fastigheten såsom infrastruktur, kommunikationer och läge.",
          },
          maklarfoto: {
            title: "MÄKLARFOTO",
            description:
              "Drönarbilder lämpar sig utmärkt för mäklare. Vi kan dokumentera en bostad både inifrån och utifrån med drönare och vanlig kamera. Vi kan även skapa digitala floorplans med 360 tours för att på ett interaktivt sätt kunna visa upp bostaden.",
          },
          evenemang: {
            title: "EVENEMANG",
            description:
              "Vi kan hjälpa till med fotografering av ditt evenemang så att det förevigas. Vi kan både fotografera från marken och från drönare.",
          },
          landskapsfoto: {
            title: "LANDSKAPSFOTO",
            description: "Har du ett vackert motiv du vill fotografera? Vi fotar landskap och arkitektur på beställning.",
          },
          bilder360: {
            title: "360 BILDER",
            description:
              "Vi kan skapa en 360 tour där användaren kan navigera runt i 360 bilder på egen hand över webben. Detta kan användas för att på ett modernt sätt visa upp en fastighet eller miljö. Vi kan också skapa floorplans där användaren får se husets interiör i en 3D-miljö.",
          },
        },
      },
      film: {
        title: "VIDEOPRODUKTION",
        description:
          "Vi kan marknadsföra ert varumärke eller fastighet med uppseendeväckande flygfilmer. Vi kan ansvara för hela produktionen och lägga till musik, grafik och logotyper. Resultatet kan anpassas efter marknadsföringskanaler såsom sociala medier, webb och storbildsskärmar. Vi kan även vara ett steg i en större produktion och bidra med flygfilm. Materialet kan levereras direkt i RAW-kvalité. Flygfilm lämpar sig väl till de flesta sorters produktioner och kan ofta vara ett bra sätt att skapa omväxling för tittaren. Utöver flygfilm jobbar vi även med vanlig filmproduktion från marken och använder då gimbal-stabilisering för att uppnå ett bra resultat.",
        productionsTitle: "Våra Produktioner",
      },
      ytmodeller: {
        title: "ORTOFOTON OCH YTMODELLER",
        description:
          "Genom att flyga med drönare på hög höjd och fotografera i sekvenser med överlapp kan man kombinera bilder för att skapa ortofoton. Ett Ortofoto kan sedan omvandlas till en Digital Terrängmodell (DTM). Genom att använda AI system för bildigenkänning kan vegetation, byggnader och andra artificiella objekt klassificeras. Därefter kan dessa plockas bort och kvar blir då endast markytan. Detta är vad man kallar en Digital Ytmodell (DSM). För att underlätta visningen av en karta kan man göra om ortofoton till konturlinjer med höjdkurvor som kan integreras direkt med era ritningar i CAD-mjukvara. Det går även att lägga över CAD-ritningar så att man kan se att bygget uppförs enligt plan. Ortofoton kan även användas till inspektion av solcellsparker eller stora fasadtak där brister kan taggas med koordinater för att enkelt kunna lokaliseras och åtgärdas.",
        sections: {
          ortofoto: {
            title: "ORTOFOTO",
            content:
              "Vi tar fram ortofoton över allt ifrån små tomter till statsdelar på flera hundra hektar. Ortofotot är högupplöst och georeffererad i erat föredragna koordinatsystem. Med ortofoton kan man exempelvis följa utveckligen på en byggarbetsplats över tid för att säkerhetställa att allt fortlöper enligt plan.",
          },
          dtm: {
            title: "DTM",
            content:
              "En digitala terrängmodell (DTM) fungerar som ett ortofoto men är färgkodat baserat på höjd. Detta gör det lättare att få perspektiv i bilden där man uppfattar djup. Det underlättar även när mätdata ska tas som exempelvis volymberäkningar.",
          },
          dsm: {
            title: "DSM",
            content:
              "En Digital Ytmodell (DSM) är liksom ett ortofoto och en DTM koordinatsatt. Skillanden är att den visar markytan utan träd, växter, hus eller infrastruktur. Detta är användbart om man planerar att avverka skog och vill kunna beräkna fyllandsmassor på marken under.",
          },
          konturlinjer: {
            title: "KONTURLINJER",
            content:
              "Konturlinjer är en förenklad kartbild som är lätt att visa och förstå. De kan skapas baserat på ortofoton med olika intervall på höjdkurvorna enligt önskemål från kunden. De kan levereras i många olika format för att passa just erat kartprogram.",
          },
          inmatning: {
            title: "INMÄTNING",
            content:
              "När en 3D modell skapas med drönare krävs det att man mäter in flygstöd för att uppnå hög noggrannhet. Vi kan utföra detta som extern tjänst där vi placerar ut markörer och mäter in i exempelvis SWEREF. Med vår RTK-utrustning vi även mäta in andra objekt såsom tomtgränser vägbanor och höjder.",
          },
        },
      },
      modeller3d: {
        title: "3D MODELLER OCH PUNKTMOLN",
        description:
          "Vi skapar och levererar högkvalitativa punktmoln och 3D modeller över stora och små områden. Vare sig syfte är att visualisera, analysera eller använda för mätdata har vi lösningen. Vi kan skapa digitala tvillingar där vi skannar en byggnad både på in- och utsidan. Med gedigen utrustning och noga kontroller säkerhetställer vi att våra modeller håller hög kvalitet. Med moderna visualiseringsprogram kan vi ger er tillgång till modellerna direkt över webben eller leverera som fil om ni föredrar att arbeta i egna program.",
        visualize: {
          title: "VISUALISERA OCH ANALYSERA",
          text: "Vi kan skapa 3D modeller där man kan montera planerad bebyggelse från exempelvis en sketch-up modell. Med \"Field of view\" kan man släppa en gubbe i modellen, likt google streetview, och ställa sig på en balkong exempelvis för att se hur utsikten kommer bli. Det går även att visualisera hus solen rör sig över huskroppar och vart skuggor hamnar under olika tider på dagen. Dessutom kan solpotential visualiseras vilket kan användas för att se vart solceller kan göra mest nytta på en fastighet. Ytterligare funktionalitet fås genom att modellera vatten i modellen och lägga in info-points.",
        },
        cards: {
          fov: "FIELD OF VIEW",
          solanalys: "SOLANALYS",
          solpotential: "SOLPOTENTIAL",
          vatten: "VATTENANALYS",
          infoPoints: "INFO POINTS",
        },
        print: {
          title: "3D UTSKRIFTER",
          text: "Vi kan omvandla digitala 3D-modeller skapade med drönare till fysiska modeller med hjälp av vår 3D-skrivare. Vi erbjuder en maximal utskriftsvolym på 30x30x40cm och en utskriftsupplösningen på 0,06 mm vilket ger otroligt detaljerade modeller.",
        },
      },
      volymberakningar: {
        title: "VOLYMBERÄKNINGAR",
        lead:
          "Volymberäkningar går att utföra i de punktmoln som skapas och ligger till grund för en 3D-modell. Det kan handla om utfyllnad eller avlägsning av massor. En volymberäkning av till exempel trädstammar kan vara ett nyttigt verktyg för att uppskatta värdet. Även beräkningar som sträckor, areor och vinklar på terrängen kan utföras i punktmoln. Vi ger kunden tillgång till materialet direkt över webben så att önskade mått enkelt kan tas, eller som fil om det föredras. Volymberäkningar i punktmoln skapade med drönare är både snabbare, smidigare och billigare än traditionella inmätningsmetoder.",
        videoTitle: "Ta gärna en titt på vår instruktionsvideo!",
        description:
          "Med hjälp av drönare och avancerad mjukvara kan vi snabbt och effektivt beräkna volymer av olika material. Våra volymberäkningar är idealiska för bergtäkter, grustag, flishögar och andra typer av materialhögar. Genom att använda fotogrammetri skapar vi exakta 3D-modeller som ger noggranna mätresultat. Detta gör det möjligt att:\n\n    • Få snabb överblick över materialvolymer\n    • Spåra förändringar över tid\n    • Optimera lagerhantering\n    • Minska mätkostnader\n    • Få tillgång till mätdata direkt via webben\n    \n    Tekniken är särskilt användbar för företag som behöver regelbunden inventering av stora materiallager.",
        accurate: {
          title: "NOGGRANNA MÄTNINGAR",
          text: "Våra drönare samlar in tusentals mätpunkter som bearbetas i specialiserad programvara. Detta ger mycket noggranna resultat som kan användas för att beräkna volymer, skapa höjdkurvor och analysera massbalanser.",
        },
        efficient: {
          title: "EFFEKTIV PROCESS",
          text: "Genom att använda drönare kan vi snabbt täcka stora områden och leverera resultat inom kort tid. Detta gör metoden både kostnadseffektiv och tidsbesparande jämfört med traditionella mätmetoder.",
        },
      },
      inspektioner: {
        title: "INSPEKTIONER",
        description:
          "Inspektion med drönare är ett smart alternativ till skylifts när det rör sig om höga och svårtillgängliga platser. I jämförelse med traditionella metoder är det mer tidseffektivt, billigare och framför allt säkrare att använda drönare. Dessutom kan inspektioner med drönare genomföras i tuffa väderförhållanden och man kan lättare komma åt svårtillgängliga platser.",
        smart: {
          title: "SMART TEKNOLOGI",
          text: "Våra drönare är utrustade med smarta sensorer som hjälper drönaren undvika hinder automatiskt. Detta möjliggör för drönaren att flyga väldigt nära objektet som inspekteras utan att riskera att egendom kommer till skada.",
        },
        situations: {
          title: "SITUATIONER",
          text: "Skorstenar, master, kraftledningar, broar, fastigheter och industrier är exempel på perfekta objekt för drönarinspektion. Fotografering och video är vanligt att använda vid inspektion av infrastruktur. Genom att använda optisk zoom kan man få en extremt detaljerad bild av ett objekt utan att behöva vara särskilt nära. Ortofoton kan användas för att inspektera vägar, tak och fasader. Fel kan markeras i bilden och taggas med koordinater så att det lätt går att hitta när det ska åtgärdas. Leveransen kan vara bilder, film, 3D modeller eller högupplösta och mätbara ortofoton över fasader och tak.",
        },
        useCasesTitle: "ANVÄNDNINGSOMRÅDEN",
        useCases: [
          "Kraftledningar",
          "Vindkraftverk",
          "Solceller",
          "Broar",
          "Vägar",
          "Samhällsanläggningar",
          "Industrier",
          "Fastigheter",
          "Telemaster",
        ],
      },
    },
    contactForm: {
      title: "Kontakta oss",
      intro:
        "Har du frågor eller vill diskutera ett projekt? Fyll i formuläret nedan så återkommer vi så snart som möjligt.",
      name: "Namn",
      email: "E-post",
      subject: "Ämne",
      phone: "Telefon (valfritt)",
      message: "Meddelande",
      send: "Skicka meddelande",
      thanksTitle: "Tack!",
      thanksText: "Ditt meddelande har skickats. Vi återkommer så snart vi kan.",
      consent: "Jag godkänner att mina uppgifter samlas in och sparas i enlighet med vår",
      consentLink: "integritetspolicy",
    },
    cookieBanner: {
      text: "Vi använder cookies för att förbättra din upplevelse på vår webbplats. Genom att fortsätta använda webbplatsen godkänner du användningen av cookies.",
      learnMore: "Läs mer",
      accept: "Acceptera",
    },
    projectsPage: {
      title: "Våra projekt",
      intro:
        "Ett urval av våra senaste projekt inom drönartjänster, från volymberäkningar till 3D-modellering.",
      selectCategory: "Välj kategori",
      allCategories: "Alla kategorier",
      projectInfo: "Projektinformation",
      client: "Kund",
      location: "Plats",
      date: "Datum",
      deliverables: "Leverabler",
      clientLabel: "Kund: ",
      mediaComingSoon: "Bildmaterial kommer snart",
      categories: {
        Flygfoto: "Flygfoto",
        Videoproduktion: "Videoproduktion",
        Ytmodeller: "Ytmodeller",
        "3D-Modeller": "3D-Modeller",
        Volymberäkningar: "Volymberäkningar",
        Inspektioner: "Inspektioner",
      },
      items: {
        jungfruholmen: {
          title: "JUNGFRUHOLMEN",
          description: "Detaljerad 3D-modell och VR-upplevelse av en hel ö",
          longDescription: "Syftet med uppdraget var att ta fram en så detaljerad 3D-modell som möjligt av ön. Detta för att kunna använda som visualiseringsunderlag för ombyggnation och renovering. Vi 3D-scannade ön, skapade modellen och gjorde en VR-upplevelse där kunden kunde hoppa in i modellen och gå runt.",
          tags: ["3D-Modellering", "VR", "Visualisering"],
        },
        fyrisskolan: {
          title: "FYRISSKOLAN",
          description: "VR-baserad brandledningsplan för skolan",
          longDescription: "Syftet med uppdraget var att ta fram en VR-baserad brandledningsplan för skolan som behövdes då skolans övervåning inte uppfyllde kraven för utrymningstillgänglighet. Vi gjorde därför en 3D-scanning utav skolan och skapade en modell som kunden sedan arbetade vidare med och skapade en VR-upplevelse baserat på.",
          tags: ["3D-Modellering", "VR", "Säkerhet"],
        },
        rotenberg: {
          title: "ROTENBERG SÄTERI",
          description: "Digital tvilling med interaktiv information och sensordata",
          longDescription: "I det här projektet tog vi fram en digital tvilling av Rotenberg Säteri. Kunden ville utvärdera möjligheten att använda modellen som en del i ett integrerat digitalt beslutssystem. Som en del i detta integrerade vi 360-bilder, info-points, videos och instruktioner i modellen. Kunden arbetade därefter vidare med att integrera data från utplacerade sensorer på gården.",
          tags: ["Digital tvilling", "3D-Modellering", "Sensorer"],
        },
        blaiken: {
          title: "BLAIKENGRUVAN STORUMAN",
          description: "Miljöåtgärder och volymberäkningar i Sorsele kommun",
          longDescription:
            "Syftet med uppdraget var att ta fram underlag för en pågående miljöåtgärd i Blaikengruvan i Sorsele kommun. Kunden ville bland annat göra beräkningar av olika slag samt simulera hur vattennivån i dagbrottet ändrade sig givet en viss vattenmängd.",
          location: "Blaiken",
          facts: { Area: "460 hektar", Upplösning: "3 cm/pixel", Noggrannhet: "ca 4 cm", "Inmätta flygstöd": "Ja", Koordinatsystem: "SWEREF 99TM" },
          tags: ["Volymberäkning", "Miljö", "3D-Modellering"],
          deliverables: ["Punktmoln (.las)", "3D modell/Mesh (.obj)", "Digital ytmodell (.tiff)", "Digital terrängmodell (.tiff)", "Ekvidistanskurvor (.shp)", "Projektrapport (.pdf)"],
        },
        upplandsbro: {
          title: "UPPLANDSBRO RANKHUS",
          description: "Drönarbilder och fotomontage för ett kommande bostadsprojekt",
          longDescription: "Syftet med uppdraget var att ta drönarbilder som skulle användas till fotomontage över ett kommande bostadsprojekt. Bilderna användes för att visualisera både under samråd i kommunen men även som marknadsföring.",
          tags: ["Flygfoto", "Fotomontage", "Fastighet"],
        },
        katarina: {
          title: "KATARINA BANGATA",
          description: "Punktmoln och komplett 3D-modell för detaljinspektion",
          longDescription: "Syftet med uppdraget var att samla in material över tak och fasader för att skapa ett punktmoln som slogs ihop med LIDAR-data inhämtat från marken. Därpå kunde en komplett 3D-modell skapas och användas för detaljinspektion av fastigheten.",
          tags: ["3D-Modellering", "Punktmoln", "Inspektion"],
        },
        palmstruchs: {
          title: "PALMSTRUCHS VÄG TÄBY",
          description: "Säljande bostadsbilder med visualisering av närområdet",
          longDescription: "I det här uppdraget blev vi anlitade av en privatkund som skulle sälja sin bostad. Kunden efterfrågade säljande bilder med visualisering av kommunikationer och området i närheten.",
          tags: ["Flygfoto", "Fastighet", "Visualisering"],
        },
        enskede: {
          title: "ENSKEDE GÅRDS GYMNASIUM",
          description: "3D-modellering och detaljinspektion av fastighet",
          longDescription: "Syftet med uppdraget var att samla in material över tak och fasader för att skapa ett punktmoln som kunde kombineras med LIDAR-data. Med hjälp av detta kunde kunden skapa en komplett 3D modell och använda för detaljinspektion av fastigheten.",
          location: "Enskede",
          facts: { Area: "1 hektar", Upplösning: "1 cm/pixel", Noggrannhet: "ca 1 cm", "Inmätta flygstöd": "Ja", Koordinatsystem: "Lokalt" },
          tags: ["3D-Modellering", "Inspektion", "Fastighet"],
          deliverables: ["Punktmoln (.las)", "Videoanimering (.mp4)", "Insamlade bilder (.jpg)", "Projektrapport (.pdf)"],
        },
        atea: {
          title: "ATEA VÄXJÖ",
          description: "Dokumentation av fastighet från marken och luften",
          longDescription: "Vi anlitades av Wilfast Fastighetsförvaltning för att dokumentera en av deras fastigheter i Växjö. Vi fotograferade både från marken och med drönare.",
          tags: ["Flygfoto", "Fastighet", "Dokumentation"],
        },
        gransoe: {
          title: "GRÄNSÖ VÄSTERVIK",
          description: "Testbädd för forskningsprojekt och simuleringar",
          longDescription: "Syftet med uppdraget var att ta fram en modell över en del av Gränsö i Västervik. Modellen skulle användas som en testbädd i olika forskningsprojekt för att kunna testa simuleringar.",
          location: "Västervik",
          facts: { Area: "42 hektar", Upplösning: "2,5 cm/pixel", Noggrannhet: "ca 15 cm", "Inmätta flygstöd": "Ja", Koordinatsystem: "WGS84" },
          tags: ["3D-Modellering", "Forskning", "Simulering"],
          deliverables: ["Punktmoln (.las)", "3D modell/Mesh (.obj)", "Insamlade bilder", "Projektrapport (.pdf)"],
        },
        hisinge: { title: "HISINGE HUS", description: "Foto- och videodokumentation av fastighet i Göteborg", longDescription: "Vi anlitades för att dokumentera en fastighet i Göteborg. Vi levererade både en video och ett flertal bilder på exteriör och interiör.", tags: ["Videoproduktion", "Flygfoto", "Fastighet"] },
        dava: { title: "DÅVA DEPONI", description: "3D-visualisering för mark- och miljödomstolen", longDescription: "Syftet med uppdraget var att samla in material till ett pågående fall i mark- och miljödomstolen där man ville kunna visualisera hur det skulle se ut att höja en sophög med 20 m. Materialet användes även av Domstolsverket i en presentation om hur ny teknik kan implementeras i domstolar.", tags: ["3D-Modellering", "Visualisering", "Miljö"] },
        plantagen: { title: "PLANTAGEN HELSINGBORG", description: "Dokumentation av fastighet från marken och luften", longDescription: "Vi anlitades av Wilfast Fastighetsförvaltning för att dokumentera en av deras fastigheter i Helsingborg. Vi fotograferade både från marken och med drönare.", tags: ["Flygfoto", "Fastighet", "Dokumentation"] },
        lidingoGolf: { title: "LIDINGÖ GOLFKLUBB", description: "Sveriges första digitala ban-tvilling", longDescription: "Syftet med uppdraget var att ta fram material för att skapa Sveriges första digitala ban-tvilling. Vi samarbetade med ett engelskt företag som baserat på 3D-modellen skapade en realistisk 3D-miljö. Klubbens medlemmar kunde sedan under vintern spela på banan inomhus i deras simulator.", tags: ["Digital tvilling", "3D-Modellering", "Golf"] },
        onninen: { title: "ONNINEN FINLAND", description: "Fastighetsfotografering i Helsingfors", longDescription: "Vi anlitades av Wilfast Fastighetsförvaltning för att dokumentera en av deras fastigheter i Helsingfors i Finland. Vi fotograferade både från marken och med drönare.", tags: ["Flygfoto", "Fastighet", "Dokumentation"] },
        svartvik: { title: "SVARTVIK STRAND", description: "Drönarbilder och fotomontage för kommande bostäder", longDescription: "Vi anlitades av Riksbyggen för att ta drönarbilder som skulle användas till fotomontage för att visa deras kommande bostadsprojekt. Bilderna hamnade även i lokaltidningen!", tags: ["Flygfoto", "Fotomontage", "Fastighet"] },
        mekonomen: { title: "MEKONOMEN GÖTEBORG", description: "Foto- och videodokumentation av fastighet i Göteborg", longDescription: "Vi anlitades för att dokumentera en fastighet i Göteborg. Vi levererade både en video och ett flertal bilder på exteriör och interiör.", tags: ["Videoproduktion", "Flygfoto", "Fastighet"] },
        bring: { title: "BRING GÖTEBORG", description: "Dokumentation av fastighet från marken och luften", longDescription: "Vi anlitades av Wilfast Fastighetsförvaltning för att dokumentera en av deras fastigheter i Göteborg. Vi fotograferade både från marken och med drönare.", tags: ["Flygfoto", "Fastighet", "Dokumentation"] },
        norraStationsgatan: { title: "NORRA STATIONSGATAN", description: "Drönarbilder som visar utsikten från framtida våningsplan", longDescription: "Syftet med uppdraget var att ta drönarbilder som skulle visa utsikten från olika våningar i ett pågående bostadsprojekt. Man ville framför allt utreda om utsikten skulle sträcka sig över vissa närliggande byggnader från specifika våningsplan.", tags: ["Flygfoto", "Fastighet", "Visualisering"] },
        rusta: { title: "RUSTA NORRKÖPING", description: "Foto- och videodokumentation av fastighet i Norrköping", longDescription: "Vi anlitades för att dokumentera en fastighet i Norrköping. Vi levererade både en video och ett flertal bilder på exteriör och interiör.", tags: ["Videoproduktion", "Flygfoto", "Fastighet"] },
      },
    },
    gdpr: {
      pageTitle: "APstudios Integritetspolicy",
      section1Title: "Behandling av personuppgifter",
      section1Text:
        "Denna dag (2019-09-09) har följande policy upprättats för APstudios (org nr 990203-6475).",
      purposeTitle: "Syfte",
      purposeText:
        "Vi värnar om din integritet. Du ska kunna känna dig trygg när du anförtror oss dina personuppgifter. Därför har vi upprättat den här policyn. Den utgår från gällande dataskyddslagstiftning och förtydligar hur vi jobbar för att ta tillvara dina rättigheter och din integritet. Syftet med den här policyn är att du ska få veta hur vi behandlar dina personuppgifter, vad vi använder dem till, vilka som får ta del av dem och under vilka förutsättningar samt hur du kan ta tillvara dina rättigheter.",
      backgroundTitle: "Bakgrund",
      backgroundText:
        "Vi behandlar dina personuppgifter främst för att fullfölja våra förpliktelser mot dig. Vår utgångspunkt är att inte behandla fler personuppgifter än vad som behövs för ändamål, och vi strävar alltid efter att använda de minst integritetskänsliga uppgifterna. Vi behöver också dina personuppgifter för att ge dig bra service exempelvis vad gäller marknadsföring, uppföljning, fakturering och information.",
      guidelinesTitle: "Riktlinjer",
      whatDataTitle: "Vilka personuppgifter behandlar vi?",
      whatDataText:
        "Vi behandlar endast personuppgifter när vi har laglig grund. Vi behandlar inte personuppgifter i annat fall än när de behövs för att fullgöra förpliktelser enligt avtal och lag.",
      whatDataListIntro: "Här följer exempel på personuppgifterna vi behandlar:",
      whatDataList: ["Namn", "Adress", "E-postadress", "Telefonnummer"],
      whatDataList2: [
        "Uppgifter som du registrerade självmant och frivilligt uppger",
        "Innehåll som du själv publicerar, s.k. användargenererat innehåll",
      ],
      howAccessTitle: "Hur får vi tillgång till dina personuppgifter?",
      howAccess1: "Vid beställning av uppdrag hos oss samtycker ni att vi behandlar era personuppgifter.",
      howAccess2:
        "Du har när som helst rätt att återkalla ditt samtycke. Vi kommer då inte längre att behandla dina personuppgifter eller inhämta nya, under förutsättning att det inte behövs för att fullgöra våra skyldigheter enligt avtal eller lag. Tänk på att återkallelse av samtycke kan innebära att vi inte kan fullgöra de skyldigheter vi har i förhållande till dig.",
      howAccess3: "Vi får också tillgång till dina personuppgifter på följande sätt:",
      howAccessList: [
        "Uppgifter som du tillhandahåller oss direkt",
        "Uppgifter som vi får när du anlitar en av våra medarbetare",
      ],
      infoToYouTitle: "Vilken information ger vi till dig?",
      infoToYouText:
        "När vi samlar in dina personuppgifter lagras detta i vårt faktureringssystem. Ansvarig för personuppgiftsbehandlingen är Oscar Hoffmann och du kan alltid kontakta oss om du har frågor eller behöver lämna en begäran eller förfrågan som avser dina personuppgifter och/eller rättigheter. Ring 072-5448860 eller maila till ",
      secureTitle: "Behandlas dina personuppgifter på ett betryggande sätt?",
      secureText:
        "Vi har rutiner och arbetssätt för att dina personuppgifter ska hanteras på ett säkert sätt. Utgångspunkten är att endast arbetstagare och andra personer inom organisationen som behöver personuppgifterna för att utföra sina arbetsuppgifter ska ha tillgång till dem. Vi överför inte personuppgifter i andra fall än de som uttryckligen anges i denna policy.",
      shareTitle: "När lämnar vi ut dina personuppgifter?",
      shareText:
        "Vår utgångspunkt är att inte lämna ut dina personuppgifter till tredje part om du inte har samtyckt till det eller om det inte är nödvändigt för att uppfylla våra förpliktelser enligt avtal eller lag.",
      responsibilityTitle: "Ansvar",
      responsibilityText:
        "APstudios är personuppgiftsansvarig, vilket innebär att vi är ansvariga för hur dina personuppgifter behandlas och att dina rättigheter tas tillvara.",
    },
  },

  en: {
    nav: {
      home: "HOME",
      services: "SERVICES",
      projects: "PROJECTS",
      contact: "CONTACT",
    },
    seo: {
      home: {
        title: "Affordable drone services across Sweden | APstudios",
        description:
          "We offer complete solutions for drone photography, video production, 360 tours, inspections, orthophotos, surface models, 3D models, surveying and volume calculations. APstudios specialises in drone services and competes on price, innovation and quality.",
      },
      foto: {
        title: "Drone images | Aerial photography | 360 images | APstudios",
        description:
          "Drone images give you a completely new perspective. Properties are an excellent subject to capture from above. Images from balcony height can show the view before a building is constructed, and photomontages can show how planned development fits into the landscape.",
      },
      film: {
        title: "Video production | Film production | APstudios",
        description:
          "Need a promotional film for a property or a brand? Clips from both the ground and the air give the film a striking feel. We can produce an entire film, with editing, music and graphics, or deliver aerial footage to a larger production.",
      },
      ytmodeller: {
        title: "Orthophotos | Surface models | Contours | Surveying | APstudios",
        description:
          "We deliver orthophotos, surface models and contour lines with high accuracy. Drone orthophotos are far more detailed than Lantmäteriet maps. We produce both DTM and DSM, and contour lines at the interval you need for CAD.",
      },
      modeller3d: {
        title: "3D models | Point clouds | Visualisation | APstudios",
        description:
          "We deliver 3D models and point clouds. Point clouds can be classified to remove vegetation, for example. 3D models are used for solar studies and visualisation, and a property model can be combined with interior laser scanning to create a digital twin.",
      },
      volym: {
        title: "Volume calculations | Quarries | Wood chips | Log piles | APstudios",
        description:
          "Companies with large stockpiles can make accurate volume calculations with ease. Whether it is wood chips, log piles or quarries, we have a practical solution and can deliver a measured point cloud in the browser.",
      },
      inspektioner: {
        title: "Inspections | Industry | Properties | APstudios",
        description:
          "High-altitude inspection is often expensive, difficult and sometimes dangerous. With a drone it becomes straightforward. Chimneys, masts, power lines, bridges, properties and industrial sites are typical subjects. Delivery can be images, film, 3D models or measurable orthophotos of facades and roofs.",
      },
      projekt: {
        title: "Projects | References | Assignments | APstudios",
        description:
          "We specialise in drone services and have many years of experience identifying applications and developing solutions for clients. We started in 2015 with the aim of leading on innovation, price and quality, and our equipment is modern and varied so it can match a client's budget and needs.",
      },
      gdpr: {
        title: "GDPR | APstudios",
        description: "Privacy policy for APstudios. How we process personal data when you contact us or commission an assignment.",
      },
    },
    services: {
      photo: "AERIAL PHOTOGRAPHY",
      video: "VIDEO PRODUCTION",
      images360: "360 IMAGES",
      surfaceModels: "SURFACE MODELS",
      models3d: "3D MODELS",
      orthophotos: "ORTHOPHOTOS",
      volumeCalculations: "VOLUME CALCULATIONS",
      inspections: "INSPECTIONS",
      measurements: "MEASUREMENTS",
      visualization: "VISUALIZATION",
    },
    hero: {
      title: "Effective Drone Solutions",
      description:
        "We offer professional drone services for all types of projects. Contact us for a free consultation.",
      contactUs: "Contact Us",
    },
    about: {
      title: "Aerial Picture Studios",
      description1:
        "We are specialists in drone services with many years of experience in identifying applications and developing solutions for customers. We started in 2015 with the vision of being at the forefront when it comes to innovation, price, and quality. Our equipment is therefore modern and diversified to adapt to the customer's budget and needs.",
      description2:
        "We hold all necessary permits and insurances required to fly drones and always take regulations and risks into account. We are based in Stockholm but carry out assignments throughout the country. You are always welcome to contact us to discuss ideas!",
    },
    serviceCards: {
      photo: {
        title: "AERIAL PHOTOGRAPHY",
        description:
          "With drone images you get a completely new perspective. Properties are an excellent subject to capture from above. Images from balcony heights to show the view before a building is constructed is a great use case. Or why not create a photomontage to show how planned development fits into the landscape?",
      },
      video: {
        title: "VIDEO PRODUCTION",
        description:
          "Need a promotional film for a property or brand? With video clips from both ground and air, the film gets an impressive feel. We can produce an entire film from start to finish with editing, music, and graphics. We can also deliver aerial footage to a larger production that wants a unique perspective.",
      },
      inspections: {
        title: "INSPECTIONS",
        description:
          "High-altitude inspection is often expensive, difficult, and sometimes dangerous, but with drones, it becomes simple and efficient. Chimneys, masts, power lines, bridges, properties, and industries are examples of perfect objects for drone inspection. Delivery can be images, film, 3D models, or high-resolution and measurable orthophotos of facades and roofs.",
      },
      surfaceModels: {
        title: "SURFACE MODELS",
        description:
          "We can deliver orthophotos, surface models, and contour lines with high accuracy. Drone orthophotos provide significantly higher detail than Lantmäteriet maps. When it comes to surface models, we can produce both DTM and DSM. Contour lines can be generated with desired height intervals and used in CAD programs.",
      },
      models3d: {
        title: "3D MODELS",
        description:
          "We can deliver 3D models and point clouds. Point clouds can be classified with advanced algorithms to, for example, remove vegetation. 3D models can be used for solar studies and visualization in various contexts. A 3D model of a property can also be complemented with laser scanning of the interior to create a digital twin.",
      },
      volumeCalculations: {
        title: "VOLUME CALCULATIONS",
        description:
          "Companies with large inventories can benefit from being able to easily make accurate volume calculations. Whether it's wood chips, log piles, or quarries, we have smart solutions. We can deliver a measured point cloud where the customer gets access directly via the web and can take measurements.",
      },
    },
    modelShowcase: {
      title: "3D models directly in the browser",
      loadModel: "Load 3D Model",
      viewMore: "View More 3D Models",
    },
    projects: {
      readMore: "View project details",
      purpose: "PURPOSE",
      facts: "FACTS",
      delivery: "DELIVERY",
      client: "CLIENT",
      blaiken: {
        title: "BLAIKEN STORUMAN",
        purpose:
          "The purpose of the assignment was to provide documentation for an ongoing environmental measure at the Blaiken mine in Sorsele municipality. The client wanted to make various calculations and simulate how the water level in the open pit changed given a certain amount of water.",
        facts: {
          area: "Location: 460 hectares",
          resolution: "Resolution: 3 cm/pixel",
          accuracy: "Accuracy: approx. 4 cm",
          flightSupport: "Measured flight support: Yes",
          coordinates: "Coordinate system: SWEREF 99TM",
        },
      },
    },
    facts: {
      area: "Location",
      resolution: "Resolution",
      accuracy: "Accuracy",
      flightSupport: "Measured flight support",
      coordinates: "Coordinate System",
    },
    testimonials: {
      title: "What Our Customers Say",
      customer: "private customer",
    },
    references: {
      title: "Our Customers",
    },
    footer: {
      about: {
        title: "ABOUT US",
        text: "We are specialists in drone services with many years of experience in identifying applications and developing solutions for customers. We hold all necessary permits and insurance required to fly drones and always take regulations and risks into account.",
      },
      info: {
        title: "INFO",
        address: "Address",
        postAddress: "Postal Address",
        email: "Email",
        phone: "Phone",
      },
      network: "We are part of the nationwide drone-services network:",
    },
    servicePage: {
      imageAlt: "image",
    },
    servicePages: {
      foto: {
        title: "PHOTOGRAPHY",
        description:
          "With drone images you can capture subjects from a whole new perspective. This opens opportunities in many industries. In real estate, drone images are highly relevant as they give an overall impression of both the plot and the building. Balcony-view images from new developments can be used to market views from different floor levels before construction. We also shoot interiors from the ground to complement the aerial images — perfect for real estate agents. Photomontages are a good way to show how planned development will sit in the landscape, and they are useful for architects and developers. A 360 tour, similar to Google Street View, lets the viewer walk through a virtual world and explore a place or a property.",
        sections: {
          utsiktsfoto: {
            title: "VIEW PHOTOGRAPHY",
            description:
              "Show the view of a new development by letting the drone fly up to the planned balcony height and capture images. A balcony railing can be composited into the image for a more realistic feel. Images can be taken in different directions.",
          },
          fotomontage: {
            title: "PHOTOMONTAGE",
            description:
              "Photomontages are, like view photography, well suited for planned buildings of various kinds. It is often useful to see in advance how a new building will fit into the environment. Photomontages are a good alternative to 3D models as they are simpler and better suited for large areas.",
          },
          fastighetsfoto: {
            title: "PROPERTY PHOTOGRAPHY",
            description:
              "We photograph all kinds of commercial and private properties, both from drone and from the ground. We can highlight key points you consider important such as infrastructure, transport links and location.",
          },
          maklarfoto: {
            title: "REAL ESTATE PHOTOGRAPHY",
            description:
              "Drone images are excellent for real estate agents. We can document a home both inside and outside using drone and regular camera. We can also create digital floor plans with 360° tours to showcase the property interactively.",
          },
          evenemang: {
            title: "EVENTS",
            description:
              "We can help photograph your event so it is preserved for the future. We shoot both from the ground and from the drone.",
          },
          landskapsfoto: {
            title: "LANDSCAPE PHOTOGRAPHY",
            description: "Have a beautiful subject you want photographed? We shoot landscapes and architecture on request.",
          },
          bilder360: {
            title: "360 IMAGES",
            description:
              "We can create a 360 tour that the viewer navigates on the web. It is a modern way to present a property or an environment. We can also create floor plans that show the interior in a 3D environment.",
          },
        },
      },
      film: {
        title: "VIDEO PRODUCTION",
        description:
          "We can promote your brand or property with striking aerial films. We can be responsible for the entire production and add music, graphics and logos. The result can be adapted to marketing channels such as social media, web and large-screen displays. We can also contribute aerial footage as one step in a larger production. Material can be delivered directly in RAW quality. Aerial film suits most types of productions and is often a great way to add variety for the viewer. In addition to aerial film, we also do regular ground-based film production using gimbal stabilization for high-quality results.",
        productionsTitle: "Our Productions",
      },
      ytmodeller: {
        title: "ORTHOPHOTOS AND SURFACE MODELS",
        description:
          "By flying drones at high altitude and capturing images in overlapping sequences, images can be combined to create orthophotos. An orthophoto can then be converted into a Digital Terrain Model (DTM). Using AI-based image recognition, vegetation, buildings and other artificial objects can be classified and then removed, leaving only the ground surface — a Digital Surface Model (DSM). To simplify map display, orthophotos can be converted into contour lines integrated directly with your CAD drawings. CAD drawings can also be overlaid to verify that construction is proceeding as planned. Orthophotos can also be used for inspecting solar parks or large facade roofs where defects can be tagged with coordinates for easy location and repair.",
        sections: {
          ortofoto: {
            title: "ORTHOPHOTO",
            content:
              "We produce orthophotos of everything from small lots to city districts covering hundreds of hectares. The orthophoto is high resolution and georeferenced in your preferred coordinate system. Orthophotos can, for example, be used to follow the progress of a construction site over time to ensure everything proceeds according to plan.",
          },
          dtm: {
            title: "DTM",
            content:
              "A Digital Terrain Model (DTM) works like an orthophoto but is color coded by elevation. This makes it easier to perceive depth and perspective in the image. It also simplifies extracting measurement data such as volume calculations.",
          },
          dsm: {
            title: "DSM",
            content:
              "A Digital Surface Model (DSM), like an orthophoto and a DTM, is coordinate referenced. The difference is that it shows the ground surface without trees, vegetation, houses or infrastructure. This is useful when planning to clear forest and calculating fill volumes on the ground below.",
          },
          konturlinjer: {
            title: "CONTOUR LINES",
            content:
              "Contour lines are a simplified map view that is easy to display and understand. They can be created from orthophotos with various height intervals according to the customer's wishes and delivered in many formats to suit your mapping software.",
          },
          inmatning: {
            title: "GROUND CONTROL",
            content:
              "When a 3D model is created with a drone, ground control points must be measured in to achieve high accuracy. We can perform this as an external service where we place markers and measure them in e.g. SWEREF. With our RTK equipment we can also measure other objects such as property boundaries, roadways and elevations.",
          },
        },
      },
      modeller3d: {
        title: "3D MODELS AND POINT CLOUDS",
        description:
          "We create and deliver high-quality point clouds and 3D models over large and small areas. Whether the purpose is to visualize, analyze or use for measurement data, we have the solution. We can create digital twins where we scan a building both inside and outside. With solid equipment and thorough quality control we ensure our models are of high quality. With modern visualization software we can give you access to the models directly on the web or deliver as a file if you prefer to work in your own program.",
        visualize: {
          title: "VISUALIZE AND ANALYZE",
          text: "We can create 3D models where planned buildings from e.g. a SketchUp model can be inserted. With \"Field of view\" you can place a person in the model, like Google Street View, and stand on a balcony to see what the view will look like. It is also possible to visualize how the sun moves across buildings and where shadows fall at different times of the day. Solar potential can be visualized to see where solar panels will be most useful on a property. Additional functionality is achieved by modeling water in the model and adding info points.",
        },
        cards: {
          fov: "FIELD OF VIEW",
          solanalys: "SOLAR ANALYSIS",
          solpotential: "SOLAR POTENTIAL",
          vatten: "WATER ANALYSIS",
          infoPoints: "INFO POINTS",
        },
        print: {
          title: "3D PRINTING",
          text: "We can convert digital 3D models created with drones into physical models using our 3D printer. We offer a maximum print volume of 30x30x40cm and a print resolution of 0.06 mm which produces incredibly detailed models.",
        },
      },
      volymberakningar: {
        title: "VOLUME CALCULATIONS",
        lead:
          "Volume calculations can be made in the point clouds that form the basis of a 3D model. That can mean fill or the removal of material. Calculating the volume of tree trunks, for example, is a useful way to estimate value. Distances, areas and angles on the terrain can also be measured in the point cloud. We give the client access to the material directly on the web so the measurements they need are easy to take, or as a file if they prefer. Volume calculations in drone point clouds are faster, simpler and less expensive than traditional surveying.",
        videoTitle: "Take a look at our instruction video.",
        description:
          "Using drones and advanced software we can quickly and efficiently calculate volumes of different materials. Our volume calculations are ideal for quarries, gravel pits, wood chip piles and other material stockpiles. Using photogrammetry we create accurate 3D models that provide precise measurement results. This makes it possible to:\n\n    • Get a quick overview of material volumes\n    • Track changes over time\n    • Optimize inventory management\n    • Reduce measurement costs\n    • Access measurement data directly via the web\n    \n    The technology is especially useful for companies that need regular inventory of large material stockpiles.",
        accurate: {
          title: "ACCURATE MEASUREMENTS",
          text: "Our drones collect thousands of measurement points that are processed in specialized software. This gives highly accurate results that can be used to calculate volumes, create contour lines and analyze mass balances.",
        },
        efficient: {
          title: "EFFICIENT PROCESS",
          text: "By using drones we can quickly cover large areas and deliver results in a short time. This makes the method both cost-effective and time-saving compared to traditional measurement methods.",
        },
      },
      inspektioner: {
        title: "INSPECTIONS",
        description:
          "Drone inspection is a smart alternative to cherry pickers when dealing with tall and hard-to-reach places. Compared to traditional methods it is more time-efficient, cheaper and above all safer to use drones. Drone inspections can also be carried out in tough weather conditions and it is easier to access hard-to-reach locations.",
        smart: {
          title: "SMART TECHNOLOGY",
          text: "Our drones are equipped with smart sensors that help the drone avoid obstacles automatically. This allows the drone to fly very close to the object being inspected without risking damage to property.",
        },
        situations: {
          title: "SITUATIONS",
          text: "Chimneys, masts, power lines, bridges, properties and industries are examples of perfect objects for drone inspection. Photography and video are commonly used when inspecting infrastructure. By using optical zoom, extremely detailed images of an object can be captured without being very close. Orthophotos can be used to inspect roads, roofs and facades. Defects can be marked in the image and tagged with coordinates for easy location and repair. Delivery can be images, film, 3D models or high-resolution measurable orthophotos of facades and roofs.",
        },
        useCasesTitle: "USE CASES",
        useCases: [
          "Power lines",
          "Wind turbines",
          "Solar panels",
          "Bridges",
          "Roads",
          "Public infrastructure",
          "Industries",
          "Properties",
          "Telecom masts",
        ],
      },
    },
    contactForm: {
      title: "Contact us",
      intro:
        "Have questions or want to discuss a project? Fill out the form below and we'll get back to you as soon as possible.",
      name: "Name",
      email: "Email",
      subject: "Subject",
      phone: "Phone (optional)",
      message: "Message",
      send: "Send message",
      thanksTitle: "Thank you!",
      thanksText: "Your message has been received. We will get back to you soon.",
      consent: "I agree that my details are collected and stored in accordance with our",
      consentLink: "privacy policy",
    },
    cookieBanner: {
      text: "We use cookies to enhance your experience on our website. By continuing to use the website, you consent to the use of cookies.",
      learnMore: "Learn more",
      accept: "Accept",
    },
    projectsPage: {
      title: "Our Projects",
      intro: "A selection of our latest drone service projects, from volume calculations to 3D modeling.",
      selectCategory: "Select category",
      allCategories: "All categories",
      projectInfo: "Project Information",
      client: "Client",
      location: "Location",
      date: "Date",
      deliverables: "Deliverables",
      clientLabel: "Client: ",
      mediaComingSoon: "Project media coming soon",
      categories: {
        Flygfoto: "Aerial photography",
        Videoproduktion: "Video production",
        Ytmodeller: "Surface models",
        "3D-Modeller": "3D models",
        Volymberäkningar: "Volume calculations",
        Inspektioner: "Inspections",
      },
      items: {
        jungfruholmen: { title: "JUNGFRUHOLMEN", description: "A detailed 3D model and VR experience of an entire island", longDescription: "The purpose of the assignment was to create as detailed a 3D model of the island as possible for use as visualization material during redevelopment and renovation. We 3D-scanned the island, created the model, and made a VR experience in which the client could enter and walk around the model.", tags: ["3D modeling", "VR", "Visualization"] },
        fyrisskolan: { title: "FYRIS SCHOOL", description: "A VR-based fire response plan for the school", longDescription: "The assignment was to create a VR-based fire response plan because the school's upper floor did not meet evacuation-accessibility requirements. We 3D-scanned the school and created a model that the client developed into a VR experience.", tags: ["3D modeling", "VR", "Safety"] },
        rotenberg: { title: "ROTENBERG MANOR", description: "A digital twin with interactive information and sensor data", longDescription: "In this project we created a digital twin of Rotenberg Manor. The client wanted to evaluate using the model in an integrated digital decision-support system. We integrated 360-degree imagery, information points, videos, and instructions into the model. The client then continued by integrating data from sensors installed around the farm.", tags: ["Digital twin", "3D modeling", "Sensors"] },
        blaiken: {
          title: "BLAIKEN MINE STORUMAN",
          description: "Environmental measures and volume calculations in Sorsele municipality",
          longDescription:
            "The purpose of the assignment was to provide documentation for an ongoing environmental measure at the Blaiken mine in Sorsele municipality. The client wanted to make various calculations and simulate how the water level in the open pit changed given a certain amount of water.",
          location: "Blaiken",
          facts: { Area: "460 hectares", Resolution: "3 cm/pixel", Accuracy: "approx. 4 cm", "Measured flight support": "Yes", "Coordinate system": "SWEREF 99TM" },
          tags: ["Volume calculation", "Environment", "3D modeling"],
          deliverables: ["Point cloud (.las)", "3D model / Mesh (.obj)", "Digital surface model (.tiff)", "Digital terrain model (.tiff)", "Contour lines (.shp)", "Project report (.pdf)"],
        },
        upplandsbro: { title: "UPPLANDSBRO RANKHUS", description: "Drone imagery and photomontages for a planned housing development", longDescription: "The purpose of the assignment was to capture drone imagery for photomontages of a planned housing development. The images were used both for visualization during the municipality's consultation process and for marketing.", tags: ["Aerial photography", "Photomontage", "Property"] },
        katarina: { title: "KATARINA BANGATA", description: "Point cloud and complete 3D model for detailed inspection", longDescription: "The assignment was to collect roof and facade data for a point cloud that was combined with ground-based LIDAR data. This made it possible to create a complete 3D model for detailed inspection of the property.", tags: ["3D modeling", "Point cloud", "Inspection"] },
        palmstruchs: { title: "PALMSTRUCHS VÄG, TÄBY", description: "Property sales imagery visualizing the surrounding area", longDescription: "A private client commissioned us while preparing to sell their home. The client requested compelling sales imagery that visualized transport links and the surrounding neighborhood.", tags: ["Aerial photography", "Property", "Visualization"] },
        enskede: {
          title: "ENSKEDE GÅRDS UPPER SECONDARY SCHOOL",
          description: "3D modeling and detailed inspection of the property",
          longDescription: "The purpose of the assignment was to collect data over roofs and facades to create a point cloud that could be combined with LIDAR data. This allowed the client to create a complete 3D model and use it for detailed inspection of the building.",
          location: "Enskede",
          facts: { Area: "1 hectare", Resolution: "1 cm/pixel", Accuracy: "approx. 1 cm", "Measured flight support": "Yes", "Coordinate system": "Local" },
          tags: ["3D modeling", "Inspection", "Property"],
          deliverables: ["Point cloud (.las)", "Video animation (.mp4)", "Collected images (.jpg)", "Project report (.pdf)"],
        },
        atea: { title: "ATEA VÄXJÖ", description: "Property documentation from the ground and the air", longDescription: "Wilfast Fastighetsförvaltning commissioned us to document one of its properties in Växjö. We photographed it both from the ground and by drone.", tags: ["Aerial photography", "Property", "Documentation"] },
        gransoe: {
          title: "GRÄNSÖ VÄSTERVIK",
          description: "Testbed for research projects and simulations",
          longDescription: "The purpose of this assignment was to produce a model of part of Gränsö in Västervik. The model would be used as a testbed in various research projects to enable simulations.",
          location: "Västervik",
          facts: { Area: "42 hectares", Resolution: "2.5 cm/pixel", Accuracy: "approx. 15 cm", "Measured flight support": "Yes", "Coordinate system": "WGS84" },
          tags: ["3D modeling", "Research", "Simulation"],
          deliverables: ["Point cloud (.las)", "3D model / Mesh (.obj)", "Collected images", "Project report (.pdf)"],
        },
        hisinge: { title: "HISINGE BUILDING", description: "Photo and video documentation of a Gothenburg property", longDescription: "We were commissioned to document a property in Gothenburg. We delivered a video and a selection of exterior and interior photographs.", tags: ["Video production", "Aerial photography", "Property"] },
        dava: { title: "DÅVA LANDFILL", description: "3D visualization for the Land and Environment Court", longDescription: "The assignment was to collect material for an ongoing Land and Environment Court case in which the proposed appearance of a 20-metre increase to a waste pile needed to be visualized. The Swedish National Courts Administration also used the material in a presentation about implementing new technology in courts.", tags: ["3D modeling", "Visualization", "Environment"] },
        plantagen: { title: "PLANTAGEN HELSINGBORG", description: "Property documentation from the ground and the air", longDescription: "Wilfast Fastighetsförvaltning commissioned us to document one of its properties in Helsingborg. We photographed it both from the ground and by drone.", tags: ["Aerial photography", "Property", "Documentation"] },
        lidingoGolf: { title: "LIDINGÖ GOLF CLUB", description: "Sweden's first digital golf-course twin", longDescription: "The assignment was to collect material for Sweden's first digital golf-course twin. We partnered with an English company that used the 3D model to create a realistic 3D environment, allowing club members to play the course indoors in their simulator during winter.", tags: ["Digital twin", "3D modeling", "Golf"] },
        onninen: { title: "ONNINEN FINLAND", description: "Property photography in Helsinki", longDescription: "Wilfast Fastighetsförvaltning commissioned us to document one of its properties in Helsinki, Finland. We photographed it both from the ground and by drone.", tags: ["Aerial photography", "Property", "Documentation"] },
        svartvik: { title: "SVARTVIK STRAND", description: "Drone imagery and photomontages for a planned housing project", longDescription: "Riksbyggen commissioned us to capture drone imagery for photomontages of its planned housing project. The images were also published in the local newspaper.", tags: ["Aerial photography", "Photomontage", "Property"] },
        mekonomen: { title: "MEKONOMEN GOTHENBURG", description: "Photo and video documentation of a Gothenburg property", longDescription: "We were commissioned to document a property in Gothenburg. We delivered a video and a selection of exterior and interior photographs.", tags: ["Video production", "Aerial photography", "Property"] },
        bring: { title: "BRING GOTHENBURG", description: "Property documentation from the ground and the air", longDescription: "Wilfast Fastighetsförvaltning commissioned us to document one of its properties in Gothenburg. We photographed it both from the ground and by drone.", tags: ["Aerial photography", "Property", "Documentation"] },
        norraStationsgatan: { title: "NORRA STATIONSGATAN", description: "Drone imagery showing views from future floors", longDescription: "The purpose of the assignment was to capture drone imagery showing the views from different floors of a housing development under construction. The client particularly wanted to determine whether views from specific floors would extend above nearby buildings.", tags: ["Aerial photography", "Property", "Visualization"] },
        rusta: { title: "RUSTA NORRKÖPING", description: "Photo and video documentation of a Norrköping property", longDescription: "We were commissioned to document a property in Norrköping. We delivered a video and a selection of exterior and interior photographs.", tags: ["Video production", "Aerial photography", "Property"] },
      },
    },
    gdpr: {
      pageTitle: "APstudios Privacy Policy",
      section1Title: "Processing of personal data",
      section1Text:
        "On this date (2019-09-09) the following policy has been established for APstudios (org. no. 990203-6475).",
      purposeTitle: "Purpose",
      purposeText:
        "We value your privacy. You should feel safe when you entrust us with your personal data. Therefore we have established this policy. It is based on current data protection legislation and clarifies how we work to safeguard your rights and privacy. The purpose of this policy is to let you know how we process your personal data, what we use it for, who receives it and under what conditions, as well as how you can exercise your rights.",
      backgroundTitle: "Background",
      backgroundText:
        "We process your personal data primarily to fulfill our obligations to you. Our starting point is not to process more personal data than is necessary for the purpose, and we always strive to use the least privacy-sensitive data. We also need your personal data to provide good service, for example regarding marketing, follow-up, invoicing and information.",
      guidelinesTitle: "Guidelines",
      whatDataTitle: "What personal data do we process?",
      whatDataText:
        "We only process personal data when we have a legal basis. We do not process personal data other than when needed to fulfill obligations under contract and law.",
      whatDataListIntro: "Examples of the personal data we process:",
      whatDataList: ["Name", "Address", "Email address", "Phone number"],
      whatDataList2: [
        "Data you register voluntarily",
        "Content you publish yourself, so-called user-generated content",
      ],
      howAccessTitle: "How do we access your personal data?",
      howAccess1: "When ordering an assignment from us, you consent to us processing your personal data.",
      howAccess2:
        "You have the right at any time to withdraw your consent. We will then no longer process your personal data or collect new data, provided this is not required to fulfill our obligations under contract or law. Note that withdrawing consent may mean that we cannot fulfill the obligations we have towards you.",
      howAccess3: "We also access your personal data in the following ways:",
      howAccessList: [
        "Data you provide us directly",
        "Data we receive when you hire one of our employees",
      ],
      infoToYouTitle: "What information do we give you?",
      infoToYouText:
        "When we collect your personal data, it is stored in our invoicing system. Responsible for personal data processing is Oscar Hoffmann and you can always contact us if you have questions or need to submit a request regarding your personal data and/or rights. Call 072-5448860 or email ",
      secureTitle: "Is your personal data processed securely?",
      secureText:
        "We have routines and procedures to handle your personal data securely. The starting point is that only employees and other persons within the organization who need the personal data to perform their tasks have access to it. We do not transfer personal data in cases other than those expressly stated in this policy.",
      shareTitle: "When do we share your personal data?",
      shareText:
        "Our starting point is not to share your personal data with third parties unless you have consented to it or it is necessary to fulfill our obligations under contract or law.",
      responsibilityTitle: "Responsibility",
      responsibilityText:
        "APstudios is the data controller, which means that we are responsible for how your personal data is processed and that your rights are safeguarded.",
    },
  },
};
